import { invariant } from '@streem/toolbox';
import { useCallback, useRef, useState } from 'react';
import { recordRequeueConfirmationCanceledClicked, recordRequeueConfirmationConfirmedClicked, } from '../components/in_call/tool_bar/tools/call_transfer/analytics-utils';
export function useCallTransferConfirmationModal(onRequeueTrade) {
    const [isOpen, setIsOpen] = useState(false);
    const requeuedTrade = useRef();
    const openModal = useCallback((newTrade) => {
        setIsOpen(true);
        requeuedTrade.current = newTrade;
    }, [setIsOpen]);
    const onConfirm = useCallback(async () => {
        invariant(requeuedTrade.current, 'new trade must be selected');
        await onRequeueTrade(requeuedTrade.current);
        setIsOpen(false);
        requeuedTrade.current = undefined;
        recordRequeueConfirmationConfirmedClicked();
    }, [onRequeueTrade, setIsOpen]);
    const onCancel = useCallback(() => {
        requeuedTrade.current = undefined;
        setIsOpen(false);
        recordRequeueConfirmationCanceledClicked();
    }, [setIsOpen]);
    return {
        isOpen,
        openModal,
        onConfirm,
        onCancel,
    };
}
//# sourceMappingURL=use_call_transfer_confirmation_modal.js.map